exports.enAPI = 'https://09q0hrnvxg.execute-api.us-east-1.amazonaws.com/api/';
exports.clienID = '7kq9ujmrjuh02tc6kgoi3d3ete';
exports.domainName = 'snaapps.auth.us-east-1.amazoncognito.com';
